<template>
  <header class="header">
    <div class="logos">
      <a class="logo-link" href="https://www.shoper.pl/" title="Idź do strony Shoper"></a>
    </div>
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style lang="scss" src="../../../assets/partner-scss/components/_header.scss"></style>
